<template>
  <b-modal
    no-close-on-backdrop
    header-bg-variant="orange"
    header-text-variant="light"
    centered
    size="xl"
    v-model="open"
    :title="title"
    :busy="loading"
    :hide-footer="true"
  >
    <b-row v-if="loading">
      <b-col cols="12" class="text-center">
        <b-spinner label="Spinning"></b-spinner>
      </b-col>
    </b-row>

    <b-row class="mt-2">
      <b-col cols="12" class="mt-3">
        <label>Buscar produto</label>
      </b-col>
      <b-col cols="12" md="8">
        <input 
          type="text"
          class="form-control" 
          v-model="productName" 
          @keyup.enter="productSearch()"
          placeholder="Nome produto, cód. barras ou marca..."
        >
      </b-col>
      <b-col cols="6" md="2" class="mt-3 mt-md-0">
        <b-button
          block
          variant="success"
          @click="productSearch()"
        >Pesquisar</b-button>
      </b-col>

      <b-col cols="6" md="2" class="mt-3 mt-md-0">
        <b-button
          block
          variant="warning"
          @click="clean()"
        >Limpar</b-button>
      </b-col>
      
      <b-col cols="12" class="mt-5">
        <b-table
          striped
          outlined
          hover
          responsive
          :fields="table.headers"
          :items="items"
          :busy="loading"
        >
        <template #cell(action)="data">
          <b-button 
            @click="deleteProduct(data.item.productId)"
            variant="danger"
            data-toggle="tooltip" data-placement="top" title="Remover Produto"
          >
            <i class="fas fa-trash"></i>
          </b-button>
        </template>

        <template #cell(qtdMeter)="data">
          {{ data.item.qtdMeter ? data.item.qtdMeter : '-' }}
        </template>

        <template #cell(photo)="data">
          <img
            :src="linkFotos(data.item.origem) + data.item.photo"
            :alt="data.item.product"
            style="width: 60px;"
          />
        </template>

        <template #cell(priceSalesFormat1)="data">
          <span>{{ formatNumber(data.item.priceSalesFormat1) }}</span>
        </template>
        </b-table>
      </b-col>
      <b-col cols="12" class="d-flex justify-content-center mt-2">
        <b-pagination
          v-model="pagination.currentPage"
          :total-rows="pagination.total"
          :per-page="pagination.itemsPerPage"
          :disabled="loading"
        ></b-pagination>
      </b-col>
    </b-row>
    <b-row class="d-flex justify-content-end">
      <b-button
        class="mr-3"
        @click="closeModal()"
        variant="danger"
      >
      Fechar
    </b-button>
    </b-row>
  </b-modal>
</template>

<script>
import makeToast from '@/mixins/makeToast';

export default {
  name: 'ProductSelectedFreigthModal',
  mixins: [makeToast],
  emits: ['addOrRemoveProduct', 'searchProduct'],

  props: {
    successUpdate: {
      type: Boolean,
      default:true
    },
    shopkeeperId: {
      type: Number,
      required:true
    },
    items: {
      type: Array,
      default: () => [],
    },
    pagination: {
      type: Object,
      default: () => ({
        currentPage: 1,
        itemsPerPage: 2,
        total: 0,
      }),
    },
  },

  data() {
    return {
      loading: false,
      productName: "",
      title: '',
      open: false,
      table:{
        headers: [
          {
            key: 'index',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          {
            key: 'photo',
            label: 'Imagem',
          },
          {
            key: 'product',
            label: 'Produto',
          },
          {
            key: 'qtdMeter',
            label: 'Qtd. por m³',
          },
          {
            key:'priceSalesFormat1',
            label: 'Preço'
          },
          {
            key: 'codbar',
            label: 'Cod. barras',
          },
          {
            key: 'brand',
            label: 'Marca',
          },
          {
            key: 'action',
            label: 'Ação',
          }
        ],
        records:[]
      },
    };
  },
  watch: {
    'pagination.currentPage': function () {
      this.productSearch(true);
    },
    'successUpdate': function () {
      if(!this.successUpdate)this.open = false;
    }
  },
  methods: {
    toggleOpen({ title = ''  }) {
      this.open = !this.open;
      this.title = title;
      this.productName = "";
      this.pagination.currentPage = 1;
    },
    linkFotos(origem) {
      if(origem == 'Belenus' || origem == 'fixadores') {
        return 'https://storage.googleapis.com/fotos-prd/';
      } else {
        return process.env.VUE_APP_FOTOS_URL;
      }
    },
    formatNumber(number) {
      return Intl.NumberFormat('pt-BR', {
        currency: 'BRL',
        style: 'currency',
      }).format(number);
    },
    closeModal(){
      this.open = !this.open;
      this.$emit('getProductSelect');
    },
    deleteProduct(id) {
      const data = {
        construpUserId: this.shopkeeperId,
        idProduct: id,
        isSelected: false,
      };
      
      this.$emit('addOrRemoveProduct', data);
   
      const indexRemove = this.items.findIndex((item) => item.productId == id);
      this.items.splice(indexRemove, 1);
    },
    productSearch(isPaginate = false) {
      if(!isPaginate && (this.productName == '' || this.productName == null)) return

      const data = {
        name: this.productName,
        page: this.pagination.currentPage,
      }

      this.$emit('searchProduct', data);
    },
    clean() {
      this.productName = "";
      this.pagination.currentPage = 1;
      this.pagination.itemsPerPage = 15;
      this.pagination.total = 1;
      
      const data = {
        name: this.productName,
        page: this.pagination.currentPage,
      }
      
      this.$emit('searchProduct', data);
     
    }
  },
};
</script>